// extracted by mini-css-extract-plugin
export default {"star":"PointCardReview_star__Uc9+q","dateText":"PointCardReview_dateText__v-Khj"};